<template>
    <el-dialog
            :visible.sync="endDialogVisible"
            width="30%"
            center>
        <div class="container jcc aic mt30">
                <img :src="flag == '1' ? succIcon : failIcon"/>
                <div class="flex aic jcc jh mt10">{{flag == '1' ? '加号成功' : '加号失败'}}</div>

                <div class="flex aic jcc mess mt80">
                    <template v-if="flag == '1'">
                        <p class="flex jcc aic">患者会收到加号成功短信通知</p>
                    </template>
                    <template v-else>
                        <p class="flex jcc aic">患者实名认证未通过，无法完成在线建档</p>
                        <p class="flex jcc aic">（需患者前往医院窗口建档）</p>
                    </template>
                </div>
        </div>
        <span slot="footer" class="dialog-footer flex aic jcc mb80">
            <div class="button flex jcc aic pointer" @click="endDialogVisible = false">知道了</div>
        </span>
    </el-dialog>
</template>

<script>
    export default {
        name: "addNum-end-dialog",
        data(){
            return {
                endDialogVisible : false,
                succIcon:require("../../assets/succeed.png"),
                failIcon:require("../../assets/error.png"),
                flag:'1'
            }
        },
        methods:{
            showSucc(flag){
                 const that = this;
                 this.flag = flag;
                 this.endDialogVisible = true;
                 setTimeout(()=>{that.hide()},5000);
            },
            hide(){
                this.endDialogVisible = false;
            }
        }
    }
</script>

<style lang="scss" scoped>
.container{
    display: flex;
    flex-direction: column;
    img{
        width:80px;
        height: 80px;
    }
    .jh{
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #333333;
    }
    .mess{
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #666666;
    }
}
.button{
    background: #3692F9;
    border-radius: 2px;
    width:137px;
    height: 32px;
    color: #ffffff;
}
</style>